import script from "./PropertyPerformanceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyPerformanceTable.vue?vue&type=script&setup=true&lang=js"

import "./PropertyPerformanceTable.vue?vue&type=style&index=0&id=c1d09298&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1d09298"]])

export default __exports__